export default __webpack_public_path__ + "static/media/careers-annex.2909adbc.jpg";